import { useMemo } from 'react';

import {
  Button,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
} from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

import { tKeys } from '@/i18n';

import { Logo } from '@/components/Common/Logo';

import { StorageKeysEnum } from '@/enums/storageKeys.enum';

import { useLocalStorage } from '@/hooks/useLocalStorage';

export const IntroModal = () => {
  const { t } = useTranslation();
  const { value: introShowed, setItem: setIntroShowed } =
    useLocalStorage<boolean>(StorageKeysEnum.introShowed);

  const showIntro = useMemo(() => !introShowed, [introShowed]);
  const handleClose = () => {
    setIntroShowed(true);
  };

  return (
    <Modal
      closeOnOverlayClick={false}
      isCentered
      isOpen={showIntro}
      onClose={handleClose}
    >
      <ModalOverlay />
      <ModalContent
        marginLeft='20px'
        marginRight='20px'
        top={{ base: '-15vh', md: '0' }}
      >
        <ModalHeader display='flex' justifyContent='center' pt='20px'>
          <Logo className='w-215px' />
        </ModalHeader>

        <ModalBody color='#101011' fontSize={{ base: '14px', md: '16px' }}>
          <Text>{t(tKeys.loginAndMakePredictions)}</Text>
          <br />
          <Text>{t(tKeys.onceYouReach)}</Text>
          <br />
          <Text>{t(tKeys.ifYouMissADAy)}</Text>
        </ModalBody>

        <ModalFooter sx={{ display: 'flex', flexDirection: 'column' }}>
          <Button
            mb='8px'
            onClick={handleClose}
            variant='primary'
            width='280px'
          >
            {t(tKeys.play)}
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};
